import { omit } from 'lodash'
import { Component } from 'react'

import Input from './Input'

interface InputTextProps {
  error?: string
  id: string
  isMultiline?: boolean
  isRequired?: boolean
  label?: string
  placeholder?: string
  registerInputCallback(...args: unknown[]): unknown
  render?(...args: unknown[]): unknown
  style?: string
  validateOverride?(...args: unknown[]): unknown
  valueOverride?(...args: unknown[]): unknown
}

export default class InputText extends Component<InputTextProps> {
  static displayName = 'InputText'

  render() {
    return <Input {...omit(this.props, 'style')} type={this.props.style || 'text'} />
  }
}
